import { RateLimiterOptions } from '../helpers/RateLimiter/RateLimiter';

export const rateLimiterOptions: RateLimiterOptions = {
    // Считаем рендеры в секунду
    interval: 1000,
    // Высокое количество рендеров на среднем железе
    threshold: 500,
    // Лимит не позволяет стригерить ошибку обычными действиями
    antiflapLimit: 14,
    // Для срабатывания ошибки из 15 интервалов нужно минимум 14 на 500+ рендеров
    antiflapTickLimit: 15,
    // Не допускаем ошибки чаще, чем раз в минуту
    errorInterval: 1000 * 60,
    // Компоненты, для которых нормально рендериться много раз
    manyRendersComponentsList: [
        /** Ячейка грида — грид большой, ячейка рендерится много раз */
        /Cell$/,
    ],
};
